<template>
  <div style="position:relative;" class="main">
    <div class="list">
      <div class="item" v-for="(item , index) in instrumentList" :key="index" @click="onClickItem(item)">
        <router-link :to="item.enabled ? item.link : ''">
          <div>
            <img style="width:24px;height:24px;" :src="item.img" alt="">
          </div>
          <div>
            <span style="color: #333333;">{{ item.name }}</span>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>

// util
import appHelper from '@util/appHelper';

export default {
  data() {
    return {
      newList: {
        img: 'icon/userIcon/wallet_icon.png',
        name: '考试',
        link: '/examination',
        enabled: true
      },
      instrumentList: [
        {
          img: 'icon/userIcon/order_icon.png',
          name: '订单',
          link: '/orderForm',
          enabled: true
        },
        // {
        //     img:'icon/userIcon/wallet_icon.png',
        //     name:'钱包',
        //     link:'/wallet',
        //     enabled : false
        // },
        {
          img: 'icon/userIcon/card_icon.png',
          name: '卡劵',
          link: '/cardroll',
          enabled: true
        },
        {
          img: 'icon/userIcon/favorite_icon.png',
          name: '收藏',
          link: '/me/myFavorite',
          enabled: true
        },
        // {
        //     img:'icon/userIcon/integral_icon.svg',
        //     name:'学分',
        //     link:'/integral',
        //      enabled : true
        // },
      ]
    }
  },
  methods: {
    onClickItem(item) {
      item.enabled ? null : appHelper.showHint('该功能暂未开放')
    }
  },
  props: {
    isExamination: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.$props.isExamination) {
      this.$data.instrumentList.splice(1, 0,this.$data.newList);
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  background: #fff;
  /*margin-top:27px;*/
  /*border-radius: 8px;*/
}

.list {
  display: flex;
  width: 100%;
  height: 67px;
  padding-top: 14px;
}

.item {
  // flex: 1;
  width: 33%;
  text-align: center;

  font-size: 14px;
  //


  font-weight: 500;
  color: #333333;

  // margin: 20px 20px;
}
</style>
